import React from 'react'
import PropTypes from 'prop-types'
import { Card, Skeleton, Typography } from '@chilecompra/react-kit/components'
import { REACT_APP_SELLER_BASE_URL } from '../../config/settings/environment'
import { GridContainer, GridItem, NewQuoteBox, AccessToNewQuote, SellerLink } from './QuoteBasicInformation.styles'
import ProtectByFeatures from '../../components/Security/ProtectByFeatures'

/**
 * Seller information component.
 */
const SellerInformation = props => {
  const { company, dni, loading, organization, causes, tcpUrl } = props
  return (
    <>
      <GridContainer padding="0 0 4px">
        <GridItem xs={12}>
          <Card color="default">
            <GridContainer>
              <GridItem xs={12}>
                <Typography color="black1" fontSize="14px" fontWeight="bold" lineHeight="18px" variant="body2">
                  {loading ? (
                    <Skeleton />
                  ) : (
                    <SellerLink target="_blank" href={`${REACT_APP_SELLER_BASE_URL}/ficha/${dni}`}>
                      {company}
                    </SellerLink>
                  )}
                </Typography>
              </GridItem>
            </GridContainer>
            <GridContainer margin="5px 0 0">
              <GridItem xs={12}>
                <Typography color="black1" fontSize="16px" lineHeight="20px" variant="body1">
                  {loading ? <Skeleton /> : dni}
                </Typography>
              </GridItem>
            </GridContainer>
            <GridContainer margin="5px 0 0">
              <GridItem xs={12}>
                <Typography color="black3" fontSize="14px" lineHeight="18px" variant="body2">
                  {loading ? <Skeleton /> : organization}
                </Typography>
              </GridItem>
            </GridContainer>
          </Card>
        </GridItem>
      </GridContainer>
      <ProtectByFeatures rule={features => features['cases.tcp']}>
        <GridContainer padding="0 0 4px">
          <GridItem xs={12}>
            <NewQuoteBox>
              <Typography color="black1" fontSize="14px" fontWeight="bold" lineHeight="18px" variant="body2">
                Demandas ante el Tribunal de Contratación Pública
              </Typography>
              <Typography variant="body2" fontSize="14px">
                {causes} &nbsp;
                <AccessToNewQuote target="_blank" href={tcpUrl}>
                  Tribunal de Contratación Pública.
                </AccessToNewQuote>
              </Typography>
            </NewQuoteBox>
          </GridItem>
        </GridContainer>
      </ProtectByFeatures>
    </>
  )
}

SellerInformation.defaultProps = {
  company: '',
  contactName: '',
  dni: '',
  email: '',
  loading: false,
  organization: '',
  phones: '',
  causes: '',
  tcpUrl: ''
}

SellerInformation.propTypes = {
  company: PropTypes.string,
  dni: PropTypes.string,
  loading: PropTypes.bool,
  organization: PropTypes.string,
  causes: PropTypes.string,
  tcpUrl: PropTypes.string
}

export default SellerInformation
